"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as Pb from "./Pb";
export class ApiError extends Error {
  constructor(message, statusCode, response) {
    super(message);
    __publicField(this, "statusCode", statusCode);
    __publicField(this, "response", response);
    this.name = "ApiError";
  }
}
function makeRequest(_0, _1, _2, _3) {
  return __async(this, arguments, function* (path, request, encoder, decoder, options = {}) {
    const { timeout = 6e4, keepalive = false } = options;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    try {
      const body = JSON.stringify(encoder(request));
      const response = yield fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body,
        signal: controller.signal,
        keepalive
      });
      clearTimeout(timeoutId);
      if (!response.ok) {
        const errorText = yield response.text();
        throw new ApiError(
          `HTTP ${response.status}: ${errorText}`,
          response.status,
          errorText
        );
      }
      const json = yield response.json();
      return decoder(json);
    } catch (error) {
      clearTimeout(timeoutId);
      if (error instanceof ApiError) {
        throw error;
      }
      if (error instanceof Error) {
        if (error.name === "AbortError") {
          throw new ApiError("Request timeout", void 0, void 0);
        }
        throw new ApiError(error.message, void 0, void 0);
      }
      throw new ApiError("Unknown error occurred", void 0, void 0);
    }
  });
}
export function addDocumentToLoadServiceUpload(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/add_document_to_load_service/upload",
      request,
      Pb.encodeAddDocumentToLoadRequest,
      Pb.decodeAddDocumentToLoadResponse,
      options
    );
  });
}
export function adminGlobalSettingsServiceIndex(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/admin/global_settings_service/index",
      request,
      Pb.encodeEmpty,
      Pb.decodeAdminGlobalSettingsServiceFlags,
      options
    );
  });
}
export function adminGlobalSettingsServiceUpdateSetting(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/admin/global_settings_service/update_setting",
      request,
      Pb.encodeAdminGlobalSettingsServiceUpdateSettingRequest,
      Pb.decodeAdminGlobalSettingsServiceUpdateSettingResponse,
      options
    );
  });
}
export function adminSearchBarServiceSearchAccounts(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/admin/search_bar_service/search_accounts",
      request,
      Pb.encodeAdminSearchBarServiceSearchAccountsRequest,
      Pb.decodeAdminSearchBarServiceSearchAccountsResponse,
      options
    );
  });
}
export function adminWorkflowServiceShow(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/admin/workflow_service/show",
      request,
      Pb.encodeWorkflowShowRequest,
      Pb.decodeWorkflowShowResponse,
      options
    );
  });
}
export function carrierInvoiceServiceUpdate(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/carrier_invoice_service/update",
      request,
      Pb.encodeCarrierInvoiceServiceUpdateRequest,
      Pb.decodeCarrierInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function carrierInvoiceServiceSubmit(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/carrier_invoice_service/submit",
      request,
      Pb.encodeCarrierInvoiceServiceSubmitRequest,
      Pb.decodeCarrierInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function carrierInvoiceServiceSaveAndApprove(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/carrier_invoice_service/save_and_approve",
      request,
      Pb.encodeCarrierInvoiceServiceSubmitRequest,
      Pb.decodeCarrierInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function customExceptionEmailTemplateServiceCreate(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/custom_exception_email_template_service/create",
      request,
      Pb.encodeCustomExceptionEmailTemplate,
      Pb.decodeEmpty,
      options
    );
  });
}
export function customExceptionEmailTemplateServiceUpdate(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/custom_exception_email_template_service/update",
      request,
      Pb.encodeCustomExceptionEmailTemplate,
      Pb.decodeEmpty,
      options
    );
  });
}
export function customExceptionEmailTemplateServiceDelete(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/custom_exception_email_template_service/delete",
      request,
      Pb.encodeCustomExceptionEmailTemplateDeleteRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
export function customExceptionEmailTemplateServiceSetAsDefault(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/custom_exception_email_template_service/set_as_default",
      request,
      Pb.encodeCustomExceptionEmailTemplateSetAsDefaultRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
export function documentLoadRelationshipServiceGetRelationshipsForDocumentsAndLoads(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/document_load_relationship_service/get_relationships_for_documents_and_loads",
      request,
      Pb.encodeDocumentLoadRelationshipRequest,
      Pb.decodeDocumentLoadRelationshipResponse,
      options
    );
  });
}
export function documentReviewServiceComplete(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/document_review_service/complete",
      request,
      Pb.encodeDocumentReviewCompletionRequest,
      Pb.decodeDocumentReviewStartNextResponse,
      options
    );
  });
}
export function documentReviewServiceStartNext(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/document_review_service/start_next",
      request,
      Pb.encodeEmpty,
      Pb.decodeDocumentReviewStartNextResponse,
      options
    );
  });
}
export function factorInvoiceServiceUpdate(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/update",
      request,
      Pb.encodeFactorInvoiceServiceUpdateRequest,
      Pb.decodeFactorInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function factorInvoiceServiceSaveWithErrors(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/save_with_errors",
      request,
      Pb.encodeFactorInvoiceServiceSaveWithErrorsRequest,
      Pb.decodeFactorInvoiceServiceSaveWithErrorsResponse,
      options
    );
  });
}
export function factorInvoiceServiceManuallyAddressRuleFailure(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/manually_address_rule_failure",
      request,
      Pb.encodeFactorInvoiceServiceManuallyAddressRuleFailureRequest,
      Pb.decodeFactorInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function factorInvoiceServiceReject(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/reject",
      request,
      Pb.encodeFactorInvoiceServiceRejectRequest,
      Pb.decodeFactorInvoiceServiceRejectResponse,
      options
    );
  });
}
export function factorInvoiceServiceResolveExceptionEvent(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/resolve_exception_event",
      request,
      Pb.encodeFactorInvoiceServiceResolveExceptionEventRequest,
      Pb.decodeFactorInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function factorInvoiceServiceCreateException(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/create_exception",
      request,
      Pb.encodeFactorInvoiceServiceCreateExceptionRequest,
      Pb.decodeFactorInvoiceServiceCreateExceptionResponse,
      options
    );
  });
}
export function factorInvoiceServiceMarkAsProcessed(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/mark_as_processed",
      request,
      Pb.encodeFactorInvoiceServiceMarkAsProcessedRequest,
      Pb.decodeFactorInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function factorInvoiceServiceMergeFrom(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/merge_from",
      request,
      Pb.encodeFactorInvoiceServiceMergeFromRequest,
      Pb.decodeFactorInvoiceServiceMergeFromResponse,
      options
    );
  });
}
export function factorInvoiceServiceSaveAndApprove(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/save_and_approve",
      request,
      Pb.encodeFactorInvoiceServiceSaveAndApproveRequest,
      Pb.decodeFactorInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function factorInvoiceServiceApprove(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/approve",
      request,
      Pb.encodeFactorInvoiceServiceSaveAndApproveRequest,
      Pb.decodeFactorInvoiceServiceUpdateResponse,
      options
    );
  });
}
export function factorInvoiceServiceAbandon(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/abandon",
      request,
      Pb.encodeFactorInvoiceServiceAbandonRequest,
      Pb.decodeFactorInvoiceServiceAbandonResponse,
      options
    );
  });
}
export function factorInvoiceServiceRevive(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/revive",
      request,
      Pb.encodeFactorInvoiceServiceReviveRequest,
      Pb.decodeFactorInvoiceServiceReviveResponse,
      options
    );
  });
}
export function factorInvoiceServiceUnapprove(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/unapprove",
      request,
      Pb.encodeFactorInvoiceServiceUnapproveRequest,
      Pb.decodeFactorInvoiceServiceUnapproveResponse,
      options
    );
  });
}
export function factorInvoiceServicePageLoaded(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/factor_invoice_service/page_loaded",
      request,
      Pb.encodeFactorInvoiceServicePageLoadedRequest,
      Pb.decodeFactorInvoiceServicePageLoadedResponse,
      options
    );
  });
}
export function insightsDashboardCustomExceptionRuleServiceRemove(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/insights_dashboard_custom_exception_rule_service/remove",
      request,
      Pb.encodeInsightsDashboardRemoveCustomExceptionRuleRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
export function insightsDashboardCustomExceptionRuleServiceRemoveAll(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/insights_dashboard_custom_exception_rule_service/remove_all",
      request,
      Pb.encodeInsightsDashboardRemoveAllCustomExceptionRulesRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
export function insightsDashboardExportDataServiceExportData(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/insights_dashboard_export_data_service/export_data",
      request,
      Pb.encodeInsightsDashboardExportDataRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
export function ltlCarrierInvoiceServiceReconcile(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/ltl_carrier_invoice_service/reconcile",
      request,
      Pb.encodeLtlCarrierInvoiceReconcileRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
export function ltlCarrierInvoiceServiceReconcileAll(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/ltl_carrier_invoice_service/reconcile_all",
      request,
      Pb.encodeCarrierInvoiceRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
export function ltlCarrierInvoiceServiceMoveToTMSQueue(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/ltl_carrier_invoice_service/move_to_tms_queue",
      request,
      Pb.encodeLtlCarrierInvoiceMoveToTMSQueueRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
export function ltlPayablesCarrierInvoiceSubmissionServiceImportToQueue(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/ltl_payables_carrier_invoice_submission_service/import_to_queue",
      request,
      Pb.encodeLtlPayablesCarrierInvoiceSubmission,
      Pb.decodeEmpty,
      options
    );
  });
}
export function pageAnnotationServiceShow(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/page_annotation_service/show",
      request,
      Pb.encodePageAnnotationServiceShowRequest,
      Pb.decodePageAnnotationServiceShowResponse,
      options
    );
  });
}
export function pageAnnotationServiceReplace(request, options) {
  return __async(this, null, function* () {
    return makeRequest(
      "/page_annotation_service/replace",
      request,
      Pb.encodePageAnnotationServiceReplaceRequest,
      Pb.decodeEmpty,
      options
    );
  });
}
